module.exports = __webpack_public_path__ + "img/island-tropical.19161bd9.svg";